var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.45,
    height: 23.98,
    viewBox: "0 0 18.45 23.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user-remove") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "user-remove"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.02, 0.02, -0.02, 1, 6.36, 8.09)",
    fontSize: 8,
    fill: "{props.color}",
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "?"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.02, 0.02, -0.02, 1, 6.36, 8.09)",
    fontSize: 8,
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "?"), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7,10.9h-.2A5.33,5.33,0,0,1,6.2,5.6,5.4,5.4,0,0,1,17,5.7,5.31,5.31,0,0,1,11.8,11h-.1ZM7.8,5.7a3.84,3.84,0,0,0,3.7,3.8h.3a3.76,3.76,0,0,0,3.6-3.8,3.8,3.8,0,0,0-7.6,0Z",
    transform: "translate(-3.8 -0.3)",
    fill: "{props.color}",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6,20.5a4.34,4.34,0,0,1-2.2-3.6A4.34,4.34,0,0,1,6,13.3a11.39,11.39,0,0,1,11.3,0,.71.71,0,0,1,.2,1.1c-.2.4-.7.4-1.1.2a9.49,9.49,0,0,0-9.5,0,2.94,2.94,0,0,0-1.5,2.3,3,3,0,0,0,1.5,2.4,9,9,0,0,0,4.8,1.3.8.8,0,0,1,0,1.6A11.27,11.27,0,0,1,6,20.5Z",
    transform: "translate(-3.8 -0.3)",
    fill: "{props.color}"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5,18.5a4.7,4.7,0,1,1,4.7,4.7A4.76,4.76,0,0,1,12.5,18.5Zm.7,0a4.1,4.1,0,1,0,4.1-4A4,4,0,0,0,13.2,18.5Z",
    transform: "translate(-3.8 -0.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.7,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.02, 0.02, -0.02, 1, 11.16, 20.23)",
    fontSize: 8,
    fill: "{props.color}",
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "x"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.02, 0.02, -0.02, 1, 11.16, 20.23)",
    fontSize: 8,
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "x")), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-3.8 -0.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-3.8 -0.3)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRemove);
export default __webpack_public_path__ + "static/media/user-remove.4a40876522afea3f018bb1ac9d01ac10.svg";
export { ForwardRef as ReactComponent };